export const FORM_FIELDS = {
  email: 'email',
  password: 'password',
} as const;
